(() => {
  const roots = document.querySelectorAll('[data-mk-records-index]');
  roots.forEach((root) => {
    if (root.dataset.bound === '1') return;
    root.dataset.bound = '1';
    const cards = [...root.querySelectorAll('[data-mk-record]')];
    cards.forEach((c,i)=>c.dataset.index=String(i));
    const perPage = Number(root.dataset.perPage || 6);
    const cause = root.querySelector('[data-filter-cause]');
    const country = root.querySelector('[data-filter-country]');
    const status = root.querySelector('[data-filter-status]');
    const year = root.querySelector('[data-filter-year]');
    const sort = root.querySelector('[data-filter-sort]');
    const count = root.querySelector('[data-count]');
    const pager = root.querySelector('[data-pager]');
    let page = 1;

    function fillSelect(select, values) {
      if (!select) return;
      const keep = select.options[0];
      select.replaceChildren(keep);
      [...new Set(values.map((v) => (v || '').trim()).filter(Boolean))]
        .sort((a, b) => a.localeCompare(b))
        .forEach((value) => {
          const option = document.createElement('option');
          option.value = value;
          option.textContent = value;
          select.appendChild(option);
        });
    }
    fillSelect(cause, cards.map((c) => c.dataset.cause));
    fillSelect(country, cards.map((c) => c.dataset.country));
    fillSelect(status, cards.map((c) => c.dataset.status));

    const hasDates = cards.some((c) => (c.dataset.date || '').trim());
    if (!hasDates) {
      if (year) year.hidden = true;
      if (sort) [...sort.options].forEach(o => { if (['recent','oldest'].includes(o.value)) o.hidden = true; });
    } else if (year) {
      const years = [...new Set(cards.map(c => (c.dataset.date || '').slice(0,4)).filter(Boolean))].sort((a,b)=>b.localeCompare(a));
      years.forEach(y => { const o=document.createElement('option'); o.value=y; o.textContent=y; year.appendChild(o); });
    }

    function matches(card){
      if (cause?.value && card.dataset.cause !== cause.value) return false;
      if (country?.value && card.dataset.country !== country.value) return false;
      if (status?.value && card.dataset.status !== status.value) return false;
      if (year?.value && !(card.dataset.date || '').startsWith(year.value)) return false;
      return true;
    }
    function sorted(list){
      const v = sort?.value || 'default';
      return [...list].sort((a,b) => {
        if (v==='az') return (a.dataset.name||'').localeCompare(b.dataset.name||'');
        if (v==='za') return (b.dataset.name||'').localeCompare(a.dataset.name||'');
        if (v==='recent') return (b.dataset.date||'').localeCompare(a.dataset.date||'');
        if (v==='oldest') return (a.dataset.date||'').localeCompare(b.dataset.date||'');
        const rank = Number(a.dataset.causeRank || 9) - Number(b.dataset.causeRank || 9);
        if (rank) return rank;
        return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      });
    }
    function render(){
      const filtered = sorted(cards.filter(matches));
      const pages = Math.max(1, Math.ceil(filtered.length/perPage));
      page = Math.min(page,pages);
      const grid = root.querySelector('.mk-record-grid');
      filtered.forEach((c) => grid.appendChild(c));
      cards.forEach((c) => { if (!filtered.includes(c)) grid.appendChild(c); });
      cards.forEach(c => c.hidden = true);
      filtered.slice((page-1)*perPage,page*perPage).forEach(c => c.hidden = false);
      if (count) count.textContent = root.dataset.countTemplate
        .replace('{from}', filtered.length ? String((page-1)*perPage+1) : '0')
        .replace('{to}', String(Math.min(page*perPage, filtered.length)))
        .replace('{total}', String(filtered.length));
      if (pager) {
        pager.innerHTML='';
        const prev=document.createElement('button'); prev.type='button'; prev.textContent=root.dataset.prev; prev.disabled=page===1; prev.onclick=()=>{page--;render()}; pager.appendChild(prev);
        for(let i=1;i<=pages;i++){const b=document.createElement('button');b.type='button';b.textContent=String(i);if(i===page)b.setAttribute('aria-current','page');b.onclick=()=>{page=i;render()};pager.appendChild(b)}
        const next=document.createElement('button'); next.type='button'; next.textContent=root.dataset.next; next.disabled=page===pages; next.onclick=()=>{page++;render()}; pager.appendChild(next);
      }
    }
    [cause,country,status,year,sort].filter(Boolean).forEach(el=>el.addEventListener('change',()=>{page=1;render()}));
    render();
  });
})();
